<template>
  <div class="news-detail">
    <headerBlack-view class="black"></headerBlack-view>
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/" class="bread-crumb wrapper">
        <el-breadcrumb-item :to="{ path: '/newhome' }">首页</el-breadcrumb-item>
        <!-- <el-breadcrumb-item :to="{ path: `/home/news?type=${$route.query.type}` }">
        {{$store.state.news.breadCrumbMap[$route.query.type]}}</el-breadcrumb-item> -->
        <el-breadcrumb-item>{{ article.title || '未知' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="news-detail-wrapper wrapper flex-between">
      <div class="news_detail_left">
        <div class="content-box">
          <div class="title-box">
            <h3 class="f18">{{ article.title }}</h3>
            <p class="source f12">
              <span> 来源：{{ article.source }}</span>
              <span> 作者：{{ article.author }} </span>
              <span> 责任编辑：{{ article.editor }}</span>
              <!-- <span> 责任编辑：张璐 </span> -->
            </p>
            <p class="other-info f12 flex-layout">
              <span>{{ article.updateTime }}</span>
              <span class="eye">{{ article.views || 0 }}</span>
            </p>
          </div>
          <div class="content" v-html="article.content">
          </div>
          <div class="pagination flex-align-between">
            <p class="pv wes" :class="[!prev.id ? 'not-hover' : '']" @click="toPage(prev)">
              上一篇：{{ prev.id ? prev.title : '无' }}</p>
            <p class="next wes" :class="[!next.id ? 'not-hover' : '']" @click="toPage(next)">
              下一篇：{{ next.id ? next.title : '无' }}</p>
          </div>

        </div>
      </div>
      <div class="news_detail_right">
        <div class="subtitle flex-align-between">
          <h2 class="text text-first flex-align">最新推荐</h2>
        </div>
        <div class="timeline-list">
          <el-timeline>
            <el-timeline-item v-for="(activity, index) in activities" :key="index" type="primary" color="#BEE3FF"
              size="large" :timestamp="activity.detailCreateTime" class="timeline-item" hide-timestamp>
              <div @click="toPage(activity)" class="timeline-item-inner">
                <p class="f12 timeline-time">{{ activity.detailCreateTime }}</p>
                <p class="f12 timeline-introduce">{{ activity.introduction }}</p>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </div>
    <scorllTop :share="false"></scorllTop>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      crumbPath: '',
      crumbName: '',
      crumbTopicListId: 1,
      article: {},
      prev: {},
      next: {},
      hasHover: false,
      activities: [{
        content: {
          time: '2020.06.03',
          text: '首都教育远程互助工程“北京-银川”“互联网+教育” “双优云桥',
        },
      }, {
        content: {
          time: '2020.06.03',
          text: '首都教育远程互助工程“北京-银川”“互联网+教育” “双优云桥',
        },
        color: '#BEE3FF'
      }, {
        content: {
          time: '2020.06.03',
          text: '首都教育远程互助工程“北京-银川”“互联网+教育” “双优云桥',
        },
        color: '#BEE3FF'
      }, {
        content: {
          time: '2020.06.03',
          text: '首都教育远程互助工程“北京-银川”“互联网+教育” “双优云桥',
        },
        color: '#BEE3FF'
      },
      {
        content: {
          time: '2020.06.03',
          text: '首都教育远程互助工程“北京-银川”“互联网+教育” 首都师京-银川”“互联京-银川”“互联京-银川”“互联范大学“双优云桥',
        },
        color: '#BEE3FF'
      }
      ]
    }
  },
  watch: {
    // $route(to, from) {
    //   document.body.scrollTop = 0
    //   document.documentElement.scrollTop = 0
    // }
  },
  computed: {

  },
  methods: {
    async getArticle() {
      let params = {
        id: this.$route.params.id
      }
      let resData = await Api.NewHome.GetNewsDetail(params);
      this.article = resData.data;
      console.log(resData);
    },

    async getRecommend() {
      let resData = await Api.NewHome.GetNewsRecommend()
      // console.log(resData);
      this.activities = resData.data;
    },

    async getNearInfo() {
      let params = {
        id: this.$route.params.id
      }
      let resData = await Api.NewHome.GetNear(params);
      this.prev = resData.data[0];
      this.next = resData.data[1];
      //console.log(resData);
    },
    toPage(item) {
      // console.log(item)
      if (item.id !== undefined) {
        Common.goPage(`/home/newslist/detail/${item.id}?type=${this.$route.query.type}`, this)
        this.init();
      }
    },
    init() {
      scroll(0, 0)
      this.getArticle();
      this.getRecommend();
      this.getNearInfo();
    },
  },
  mounted() {
    this.init();
  },
}
</script>

<style lang="less" scoped>
@basisColor: #508EF9;
@bgColor: #FAFAFA;
@white: #fff;

.news-detail {
  background-color: #FAFAFA !important;

  .breadcrumb-box {
    width: 1200px;
    margin: 30px auto;
  }

  .news-detail-wrapper {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 150px;
  }

  .news_detail_left {
    box-sizing: border-box;
    padding: 28px 33px;
    width: 677px;
    border-radius: 8px;

    background-color: #fff;

    .title-box {
      border-bottom: 1px solid #E4E4E4;

      h3 {
        margin-bottom: 8px;
        color: #508EF9;
        font-weight: bold;
      }

      p {
        color: #999;
        margin-bottom: 10px;
      }

      .eye {
        display: inline-flex;
        align-items: center;

        margin-bottom: 7px;
        margin-left: 28px;
      }

      .eye::before {
        content: ' ';
        display: inline-block;

        margin-right: 4px;
        width: 20px;
        height: 20px;

        background-image: url("../../assets/common/eye.png");
        background-size: 20px 20px;
        background-repeat: no-repeat;
      }

      .source span {
        margin-right: 10px;
      }
    }

    .content {
      padding: 30px 0 50px;
      border-bottom: 1px solid #E4E4E4;

      img {
        max-width: 100%;
      }

      p,
      span {
        word-break: break-all;
      }
    }

    .pagination {
      p {
        padding: 23px 0 0;
        max-width: 45%;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
          color: #508EF9;
        }
      }

      p.not-hover:hover {
        text-decoration: none;
        color: #333;
        cursor: default;
      }
    }




  }

  .news_detail_right {
    width: 300px;
    flex-shrink: 0;
    border-radius: 8px;
    height: fit-content;
    background-color: #fff;
    overflow: hidden;

    .subtitle {
      padding: 0 22px;
      border-bottom: 1px dashed #508EF9;
      height: 49px;
      font-size: 13px;

      color: #508EF9;

      .text::before {
        content: ' ';
        display: inline-block;

        margin-right: 11px;
        width: 16px;
        height: 20px;
      }

      .text-first::before {
        background-image: url("~@/assets/common/recommed.png");
        background-repeat: no-repeat;
      }
    }

    /deep/ .timeline-list {
      padding: 28px 20px 0;

      .timeline-item {
        cursor: pointer;
        line-height: 20px;

        .el-timeline-item__tail {
          border-left: 1px solid rgba(80, 142, 249, .3);
        }

        &:first-child .el-timeline-item__tail {
          height: 130%;
          top: -10px;
        }

        &:nth-last-child(2) .el-timeline-item__tail {
          height: 1000%;
        }

        .timeline-time {
          margin-bottom: 5px;
        }

        .timeline-introduce {
          line-height: 22px;
        }
      }

      .timeline-item::before {
        content: ' ';
        display: inline-block;
        position: absolute;
        top: 3px;
        left: 1px;
        z-index: 999;

        border-radius: 50%;
        width: 8px;
        height: 8px;

        background-color: #508EF9;
      }

      .timeline-item-inner:hover {
        color: #508EF9;
      }
    }
  }

  @media screen and (min-width:1250px) {
    .news_detail_left {
      padding: 36px 40px;
      width: 820px;
    }

    .news_detail_right {
      width: 364px;

      .subtitle {
        padding: 0 22px;
        height: 60px;
        font-size: 16px;
      }
    }
  }

}
</style>